import { Container, Row, Col, Badge } from 'reactstrap';
import './style.css';

const showcaseWebsites = [
  {
    title: "Modern Restaurant",
    category: "Restaurant",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop",
    description: "Elegant dining experience with online reservations"
  },
  {
    title: "Tech Startup",
    category: "Technology",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
    description: "Clean, modern design showcasing innovation"
  },
  {
    title: "Fashion Boutique",
    category: "E-commerce",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop",
    description: "Stylish online store with seamless shopping"
  },
  {
    title: "Real Estate Agency",
    category: "Real Estate",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop",
    description: "Professional property showcase with search"
  },
  {
    title: "Fitness Studio",
    category: "Health & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop",
    description: "Energetic design with class booking system"
  },
  {
    title: "Law Firm",
    category: "Professional Services",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop",
    description: "Trust-building design with consultation booking"
  }
];

export default function ShowcaseSection() {
  return (
    <section className="showcase-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="showcase-title">See What We've Built for Others</h2>
          <div className="showcase-lead">
            Real websites for real businesses - yours could be next!
          </div>
        </div>
        <Row>
          {showcaseWebsites.map((website, i) => (
            <Col xs="12" md="6" lg="4" className="mb-4" key={i}>
              <div className="showcase-card">
                <div className="showcase-card-img-wrap">
                  <img
                    src={website.image}
                    alt={website.title}
                    className="showcase-img"
                  />
                  <Badge className="showcase-badge" color="light">
                    {website.category}
                  </Badge>
                </div>
                <div className="showcase-card-body">
                  <h5 className="showcase-card-title">{website.title}</h5>
                  <div className="showcase-card-desc">{website.description}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-4">
          <button className="showcase-btn">
            View All Our Work
          </button>
        </div>
      </Container>
    </section>
  );
}
